module.exports = "/_next/static/images/0bd559691b560fa402b334de89d475c4-card-lg.png.webp";